<table class="table-fixed w-full table-striped">
  <thead class="h-[50px] w-full !z-30 sticky top-0 bg-[#1A4971]">
    <tr class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6]">
      <th class="p-2 pl-[2rem] !font-Roboto !text-left">ID</th>
      <th class="p-2 !font-Roboto !text-left">User Name</th>
      <th class="p-2 !text-left">Email</th>
      <th class="p-2 !text-left">Telephone No</th>
      <th class="p-2 !text-left">Roles</th>
      <th class="p-2 !text-left">Action</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="users && users?.length > 0">
      <tr
        *ngFor="let user of users; let i = index"
        class="hover:bg-muted/50 !font-Roboto !cursor-default !h-[43px]"
      >
        <td class="border-b p-2 pl-[2rem] !text-left cursor-pointer">
          {{ user?.id }}
        </td>
        <td class="border-b p-2 !text-left">
          {{ user?.name }}
        </td>

        <td class="border-b p-2 !text-left">
          {{ user?.email }}
        </td>
        <td class="border-b p-2 !text-left">
          {{ user?.phone }}
        </td>
        <td class="border-b p-2 !text-left">
          {{ getRoleNames(user?.roles) }}
        </td>
        <td class="border-b p-2 !text-left">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editUser(user)">
              <mat-icon color="primary">edit</mat-icon> Edit
            </button>
            <button mat-menu-item (click)="deleteUser(user.id)">
              <mat-icon color="warn">delete</mat-icon> Delete
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<!-- Loader if data is loading -->
<div *ngIf="users.length === 0" class="empty-state">
  No users found. Please add users.
</div>
<!-- Inline Role Dialog Template -->
<ng-template #addUserDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">
        {{ editUserId ? "Update Existing User" : "Add New User" }}
      </h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <form [formGroup]="userForm" (ngSubmit)="createUser()">
      <div class="grid grid-cols-2 gap-4">
        <!-- First Name -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>First Name</mat-label>
            <input
              matInput
              type="text"
              id="firstName"
              formControlName="firstName"
              placeholder="Enter First Name"
            />
            <mat-error
              *ngIf="
                userForm.get('firstName')?.invalid &&
                userForm.get('firstName')?.touched
              "
            >
              First Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Last Name -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              type="text"
              id="lastName"
              formControlName="lastName"
              placeholder="Enter Last Name"
            />
            <mat-error
              *ngIf="
                userForm.get('lastName')?.invalid &&
                userForm.get('lastName')?.touched
              "
            >
              Last Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Telephone -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Telephone No</mat-label>
            <input
              matInput
              type="text"
              id="telephone"
              formControlName="telephone"
              placeholder="Enter Telephone No"
            />
            <mat-error
              *ngIf="
                userForm.get('telephone')?.invalid &&
                userForm.get('telephone')?.touched
              "
            >
              Telephone number is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Email -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="email"
              id="email"
              formControlName="email"
              placeholder="Enter Email"
            />
            <mat-error
              *ngIf="
                userForm.get('email')?.invalid && userForm.get('email')?.touched
              "
            >
              Valid Email is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Role Selection (Multi-Select) -->
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Select Roles</mat-label>
          <mat-select formControlName="roles" multiple>
            <mat-option *ngFor="let role of roles" [value]="role.id">
              {{ role.name }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              userForm.get('roles')?.invalid && userForm.get('roles')?.touched
            "
          >
            At least one role is required
          </mat-error>
        </mat-form-field>

        <!-- Password -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              id="password"
              formControlName="password"
              placeholder="Enter Password"
            />
            <mat-error
              *ngIf="
                userForm.get('password')?.invalid &&
                userForm.get('password')?.touched
              "
            >
              Password is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Confirm Password -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              type="password"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Confirm Password"
            />
            <mat-error
              *ngIf="
                userForm.get('confirmPassword')?.invalid &&
                userForm.get('confirmPassword')?.touched
              "
            >
              Confirm Password is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="dialog-actions">
        <button class="submit-btn" type="submit" [disabled]="userForm.invalid">
          {{ editUserId ? "Update User" : "Add User" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
